import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { Content } from 'core/layouts';
import { BaasicModal, BaasicFormControls, BasicInput, BaasicButton, BaasicFieldDropdown, NumericInputField } from 'core/components';
import { FacilityOrderTemplateMissingDocumentNoteModal, FacilityOrderTemplatePNMissingInformationModal } from "application/facility-order/components";
import { FacilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModal } from "application/facility-order-new-flow-us-intake/components";
import { FacilityOrderTemplateNewFlowCustomOrderingDoctorAdd } from "application/facility-order-new-flow/components";
import { Button } from "@progress/kendo-react-buttons";
import { uuid } from "core/utils";
function FacilityOrderTemplateNewFlowUSIntakeClinicalInformationModalTemplate({ facilityOrderTemplateNewFlowUSIntakeClinicalInformationModalStore, t }) {
	const {
		loadingData,
		contentLoading,
		form,
		modalParams,
		clinicalStatusStore,
		doctorStore,
		dxCode1Store,
		dxCode2Store,
		dxCode3Store,
		dxCode4Store,
		dxCode5Store,
		dxCode6Store,
		dxCode7Store,
		dxCode8Store,
		missingDocumentStore,
		openFacilityOrderTemplateMissingDocumentNoteModal,
		facilityOrderTemplateMissingDocumentNoteModal,
		generateStandardWrittenOrder,
		generateMedicalNecessityForm,
		facilityOrderTemplatePNMissingInformationModal,
		isEligible,
		syncOrderingDoctors,
		isSyncInProgress,
		generateMedicalNecessityFormAndStandardWrittenOrder,
		onHeightWeightFocus,
		facilityOrderTemplate,
		openFacilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModal,
		facilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModal,
		facilityOrderPatient,
		patient,
		missingDocsPreviousValue,
		disabled 
	} = facilityOrderTemplateNewFlowUSIntakeClinicalInformationModalStore;

	const tagRender = (tagData, li) => React.cloneElement(li, { children: <span key={uuid()} onClick={() => openFacilityOrderTemplateMissingDocumentNoteModal(tagData.data[0])}>{tagData.data[0].name}</span> });

	const dxCodeDropdownItemRender = (li, itemProps) => {
		const itemName = itemProps && itemProps.dataItem.name;
		const itemChildren = (
			<span style={{ display: "flex", flexDirection: "column", width: "100%", }}>
				<span style={{ flex: "1" }}> {li.props.children} </span>
				<span style={{ fontSize: "12px" }}>{itemName} </span>
			</span>
		);
		return React.cloneElement(li, li.props, itemChildren);
	}

	return (
		<div style={{ minHeight: 444 }}>
			<Content loading={contentLoading || loadingData}>
				<div className="modal__header">
					<h3 className='modal__header__title'>Clinical Information</h3>
				</div>
				<div className='u-flex--align-end u-flex--justify-end u-mar--bottom--sml'>
					{
						isEligible &&
						<React.Fragment>
							{facilityOrderTemplate.clinicalStatus && facilityOrderTemplate.clinicalStatus.name != "Covered" && facilityOrderTemplate.clinicalStatus.name != "Prior Auth Obtained" && facilityOrderTemplate.clinicalStatus.name != "Does Not Meet Insurance Criteria" &&
								<div>
									<Button className="btn btn--link btn--icon--sml-med" icon="u-icon u-icon--med u-icon--us-note" onClick={() => openFacilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModal()} disabled={disabled || form.submitting} data-tooltip-content="Clinical Status Note" />
								</div>
							}
							<div className='is-blue'>
								<BaasicFieldDropdown className="k-dropdown--primary k-dropdown--nowrap" field={form.$('clinicalStatusId')} store={clinicalStatusStore} toolTipPlace='left' showChangeFlag={facilityOrderTemplate.templateId && facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.clinicalStatusId != facilityOrderTemplate.facilityOrderTemplateInitial.clinicalStatusId} previousValue={facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.facilityOrderTemplateInitial.clinicalStatus && facilityOrderTemplate.facilityOrderTemplateInitial.clinicalStatus.name} disabled={disabled}/>
							</div>
						</React.Fragment>
					}
					<div className="status--sqare__wrapper u-mar--left--tny">
						<Button className="btn btn--icon btn--icon--sml-med btn--light" icon="u-icon u-icon--med u-icon--clinical-review" disabled={disabled}/>
					</div>
				</div>
				<div className="modal__body is-blue">
					<div className="row">
						<div className="form__group col col-lrg-12">
							<BasicInput field={form.$('note')} toolTipPlace='left' showChangeFlag={facilityOrderTemplate.templateId && facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.note != facilityOrderTemplate.facilityOrderTemplateInitial.note} previousValue={facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.facilityOrderTemplateInitial.note} disabled={disabled}/>
						</div>
					</div>
					<div className="row">
						<div className="form__group col col-lrg-12">
							<BasicInput field={form.$('swo')} toolTipPlace='left' showChangeFlag={facilityOrderTemplate.templateId && facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.swo != facilityOrderTemplate.facilityOrderTemplateInitial.swo} previousValue={facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.facilityOrderTemplateInitial.swo} disabled={disabled}/>
						</div>
					</div>
					<div className="row" >
						<div className="form__group col col-lrg-3">
							<BaasicFieldDropdown field={form.$('dxCode1')} store={dxCode1Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} showChangeFlag={facilityOrderTemplate.templateId && facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.dxCode1 != facilityOrderTemplate.facilityOrderTemplateInitial.dxCode1} previousValue={facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.facilityOrderTemplateInitial.dxCode1} disabled={disabled}/>
						</div>
						<div className="form__group col col-lrg-3">
							<BaasicFieldDropdown field={form.$('dxCode2')} store={dxCode2Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} showChangeFlag={facilityOrderTemplate.templateId && facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.dxCode2 != facilityOrderTemplate.facilityOrderTemplateInitial.dxCode2} previousValue={facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.facilityOrderTemplateInitial.dxCode2} disabled={disabled}/>
						</div>
						<div className="form__group col col-lrg-3 ">
							<BaasicFieldDropdown field={form.$('dxCode3')} store={dxCode3Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} showChangeFlag={facilityOrderTemplate.templateId && facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.dxCode3 != facilityOrderTemplate.facilityOrderTemplateInitial.dxCode3} previousValue={facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.facilityOrderTemplateInitial.dxCode3} disabled={disabled}/>
						</div>
						<div className="form__group col col-lrg-3">
							<BaasicFieldDropdown field={form.$('dxCode4')} toolTipPlace='left' store={dxCode4Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} showChangeFlag={facilityOrderTemplate.templateId && facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.dxCode4 != facilityOrderTemplate.facilityOrderTemplateInitial.dxCode4} previousValue={facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.facilityOrderTemplateInitial.dxCode4} disabled={disabled}/>
						</div>
					</div>
					<div className="row" >
						<div className="form__group col col-lrg-3">
							<BaasicFieldDropdown field={form.$('dxCode5')} store={dxCode5Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} showChangeFlag={facilityOrderTemplate.templateId && facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.dxCode5 != facilityOrderTemplate.facilityOrderTemplateInitial.dxCode5} previousValue={facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.facilityOrderTemplateInitial.dxCode5} disabled={disabled}/>
						</div>
						<div className="form__group col col-lrg-3">
							<BaasicFieldDropdown field={form.$('dxCode6')} store={dxCode6Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} showChangeFlag={facilityOrderTemplate.templateId && facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.dxCode6 != facilityOrderTemplate.facilityOrderTemplateInitial.dxCode6} previousValue={facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.facilityOrderTemplateInitial.dxCode6} disabled={disabled}/>
						</div>
						<div className="form__group col col-lrg-3 ">
							<BaasicFieldDropdown field={form.$('dxCode7')} store={dxCode7Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} showChangeFlag={facilityOrderTemplate.templateId && facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.dxCode7 != facilityOrderTemplate.facilityOrderTemplateInitial.dxCode7} previousValue={facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.facilityOrderTemplateInitial.dxCode7} disabled={disabled}/>
						</div>
						<div className="form__group col col-lrg-3">
							<BaasicFieldDropdown field={form.$('dxCode8')} toolTipPlace='left' store={dxCode8Store} allowEmpty={true} itemRender={dxCodeDropdownItemRender} showChangeFlag={facilityOrderTemplate.templateId && facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.dxCode8 != facilityOrderTemplate.facilityOrderTemplateInitial.dxCode8} previousValue={facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.facilityOrderTemplateInitial.dxCode8} disabled={disabled}/>
						</div>
					</div>
					<div className="row">

						<div className="form__group col col-med-6">
							<div className="form__group__label">
								{t(form.$('orderingDoctorId').label)}
								<i title='Sync Ordering Doctors' className={`u-icon u-icon--sml u-icon--synchronize--${isSyncInProgress || disabled ? "grey" : "primary"} u-mar--left--tny`} onClick={ disabled ? () => {} : () => syncOrderingDoctors()}></i>
							</div>
							<BaasicFieldDropdown field={form.$('orderingDoctorId')} store={doctorStore} allowEmpty={true} labelDisplayed={false} showChangeFlag={facilityOrderTemplate.templateId && facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.orderingDoctorId != facilityOrderTemplate.facilityOrderTemplateInitial.orderingDoctorId} previousValue={facilityOrderTemplate.facilityOrderTemplateInitial && (facilityOrderTemplate.facilityOrderTemplateInitial.orderingDoctor ? facilityOrderTemplate.facilityOrderTemplateInitial.orderingDoctor.name : '')} disabled={disabled}/>
						</div>
						<div className="form__group col col-lrg-3">
							<NumericInputField field={form.$('height')} setDefaultType={true} showSpinners={false} onClick={(e) => onHeightWeightFocus(e)}  toolTipPlace='left' showChangeFlag={facilityOrderTemplate.templateId && facilityOrderPatient && facilityOrderPatient.facilityOrderPatientInitial && patient.height != facilityOrderPatient.facilityOrderPatientInitial.height} previousValue={facilityOrderPatient && facilityOrderPatient.facilityOrderPatientInitial && (facilityOrderPatient.facilityOrderPatientInitial.height != null ? facilityOrderPatient.facilityOrderPatientInitial.height : '')} disabled={disabled}/>
						</div>
						<div className="form__group col col-lrg-3">
							<NumericInputField field={form.$('weight')} setDefaultType={true} showSpinners={false} onClick={(e) => onHeightWeightFocus(e)} toolTipPlace='left' showChangeFlag={facilityOrderTemplate.templateId && facilityOrderPatient && facilityOrderPatient.facilityOrderPatientInitial && patient.weight != facilityOrderPatient.facilityOrderPatientInitial.weight} previousValue={facilityOrderPatient && facilityOrderPatient.facilityOrderPatientInitial && (facilityOrderPatient.facilityOrderPatientInitial.weight != null ? facilityOrderPatient.facilityOrderPatientInitial.weight : '')} disabled={disabled}/>
						</div>
					</div>
					<div className="row">
						<div className="form__group col col-lrg-12">
							<BaasicFieldDropdown field={form.$('facilityOrderTemplateMissingDocuments')} store={missingDocumentStore} multi={true} tagRender={tagRender} toolTipPlace='left' showChangeFlag={facilityOrderTemplate && facilityOrderTemplate.templateId && missingDocsPreviousValue != null} previousValue={missingDocsPreviousValue != null && missingDocsPreviousValue} disabled={disabled}/>
						</div>
					</div>

					<label className="form__group__label">Generate Documents: </label>
					<div className="u-flex--default btn--grouped">
						<BaasicButton
							onlyIcon={true}
							className='btn btn--sml btn--light t u-mar--right--tny'
							label='SWO & PN'
							icon="u-icon u-icon--sml u-icon--download--brand"
							onClick={() => generateMedicalNecessityFormAndStandardWrittenOrder()}
						/>
						<BaasicButton
							className='btn btn--sml btn--light t u-mar--right--tny'
							label='SWO'
							onClick={() => generateStandardWrittenOrder()}
						/>
						<BaasicButton
							className='btn btn--sml btn--light t u-mar--right--tny'
							label='PN'
							onClick={() => generateMedicalNecessityForm()}
						/>
						<FacilityOrderTemplateNewFlowCustomOrderingDoctorAdd facilityOrderTemplate={facilityOrderTemplate} isClinicalInfoModal={true}/>
					</div>
				</div>
				<div className='u-separator--primary  u-mar--top--sml'></div>
				<div className='modal__footer is-right'>
					<BaasicButton
						className='btn btn--med btn--light'
						label={t('EDIT_FORM_LAYOUT.CANCEL')}
						onClick={() => modalParams.close()}
						disabled={disabled || form.submitting || form.validating}
					/>
					<BaasicFormControls
						form={form}
						className='btn btn--med btn--primary'
						onSubmit={form.onSubmit}
						disabled={disabled || form.submitting || form.validating}
						label={t('EDIT_FORM_LAYOUT.SAVE')}
					/>
				</div>

				<BaasicModal modalParams={facilityOrderTemplateMissingDocumentNoteModal}>
					<FacilityOrderTemplateMissingDocumentNoteModal />
				</BaasicModal>
				<BaasicModal modalParams={facilityOrderTemplatePNMissingInformationModal} className="modal__content modal--med">
					<FacilityOrderTemplatePNMissingInformationModal />
				</BaasicModal>
				<BaasicModal modalParams={facilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModal} className="modal__content modal--med">
					<FacilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModal />
				</BaasicModal>
			</Content>
		</div>
	)
}

FacilityOrderTemplateNewFlowUSIntakeClinicalInformationModalTemplate.propTypes = {
	facilityOrderTemplateNewFlowUSIntakeClinicalInformationModalStore: PropTypes.object,
	t: PropTypes.func
};

export default defaultTemplate(FacilityOrderTemplateNewFlowUSIntakeClinicalInformationModalTemplate);
